export default __webpack_public_path__ + "static/media/profileEdit.40db67d9.png";